import { createRoot } from 'react-dom/client'
import Handlebars from 'handlebars'

import App from './App'
import * as serviceWorker from './serviceWorker'
import 'antd/dist/reset.css'
import './style.css'

Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
  // @ts-ignore
  return arg1 === arg2 ? options.fn(this) : options.inverse(this)
})

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Failed to find the root element')
}

const root = createRoot(rootElement)

root.render(<App />)

serviceWorker.unregister()
